import React, { Fragment } from 'react';
import formatDate from 'utils/formatDate';

const OrganisationInfo = ({ customer, isSrmAdmin }) => (
  <dl>
    <dt>Active subscription:</dt>
    <dd>
      {customer.subscription
        ? customer.subscription.name
        : 'Please contact us to subscribe.'}
    </dd>
    {customer.subscription && (
      <Fragment>
        <dt>Created</dt>
        <dd>{formatDate(customer.subscription.created)}</dd>
        {customer.subscription.expiry ? (
          <>
            <dt>Expires</dt>
            <dd>{formatDate(customer.subscription.expiry)}</dd>
          </>
        ) : (
          <></>
        )}
      </Fragment>
    )}
    {isSrmAdmin && (
      <Fragment>
        <dt>Customer type</dt>
        <dd>{customer.type}</dd>
      </Fragment>
    )}
    {customer.trialActive && (
      <Fragment>
        <dt>Trial status</dt>
        <dd>
          A trial subscription is currently active until {customer.trialEnds}.
        </dd>
      </Fragment>
    )}
  </dl>
);
export default OrganisationInfo;
